import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsSwap01 = function CoinsSwap01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m6 6 2-2m0 0L6 2m2 2H6C3.7909 4 2 5.7909 2 8m16 10-2 2m0 0 2 2m-2-2h2c2.2091 0 4-1.7909 4-4m-8.5828-2.5828C14.1994 13.7908 15.0753 14 16 14c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6c0 .9247.2092 1.8006.5828 2.5828M14 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    })
  }));
};
export default CoinsSwap01;